export const translatePolicyType = (policyType) => {
    const policyTypeTranslations = {
        INDIVIDUALPOLICY: "Police individuelle",
        FLEETPOLICY: "Police de flotte",
    };
    return policyTypeTranslations[policyType] || policyType;
};